import { useId } from 'react';

/**
 * Returns a unique ID that will stay the same across re-renders
 * @param prefix Optional prefix for the ID (defaults to `"id"`)
 */
const useUniqueId = (prefix = 'id'): string => {
  const id = useId()
    // it's possible that the ID will have special characters in it. We want to
    // ensure that it can be a valid CSS ID or class name, so we'll replace any
    // invalid characters with underscores. From what we can tell the special
    // character is always a `:` so there should be little chance of name
    // collisions, but in theory that could change in the future. More info:
    // https://github.com/facebook/react/issues/26839
    .replace(/[^A-Za-z0-9-_]/g, '_');

  return `${prefix}${id}`;
};

export default useUniqueId;
